<section class="projects-section">
    <div class="container">

        <div class="card">

            <!-- HEADER -->
            <div class="page-header">
                <h3 class="page-title">
                    Microservice Permissions
                </h3>
            </div>

            <!-- LOADING -->
            <div *ngIf="loading" class="no-data">
                Loading permissions...
            </div>

            <!-- CONTENT -->
            <div *ngIf="!loading">

                <!-- EMPTY STATE -->
                <div class="no-data" *ngIf="scopes.length === 0">
                    <i class="fa-solid fa-shield-halved"></i>
                    No permissions assigned to this microservice
                </div>

                <!-- SCOPED PERMISSIONS -->
                <div *ngFor="let scope of scopes" class="scope-block">

                    <h4 class="scope-title">
                        {{ scope | uppercase }} SCOPE
                        <span class="count">
                            ({{ groupedPermissions[scope].length }})
                        </span>
                    </h4>

                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Permission</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let p of groupedPermissions[scope]; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>
                                    <code>{{ p }}</code>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>

        </div>

    </div>
</section>